// frontend/src/pages/PaychequeDetail/usePaychequeDetail.ts
// React Query hook for a single paycheque's full detail.

import { useQuery } from "@tanstack/react-query";
import apiFetch from "../../utils/apiFetch";
import { authHeaders } from "./helpers";
import type { PaychequeDetail } from "./types";

/**
 * Fetches a single paycheque's full detail by id.
 * Returns typed useQuery result; disabled until an id is provided.
 *
 * Error handling distinguishes 401 (auth), 404 (not found), and other failures
 * so the UI can show the most useful message.
 */
export function usePaychequeDetail(id: string | undefined) {
  return useQuery<PaychequeDetail>({
    queryKey: ["paycheque-detail", id],
    queryFn: async function () {
      const res = await apiFetch("/api/v1/payroll/paycheques/" + id, {
        headers: authHeaders(),
      });
      if (!res.ok) {
        if (res.status === 401) throw new Error("Invalid or expired token. Please log in again.");
        if (res.status === 404) throw new Error("Paycheque not found.");
        throw new Error("Could not load paycheque");
      }
      return await res.json();
    },
    enabled: !!id,
    refetchOnWindowFocus: false,
  });
}